import { LegalClientLegalHeadEntity } from 'api/types/entity';
import { formatToDate } from 'helpers';
import { TFunc } from 'libs/i18n';
import {
  parseAddressValue,
  parseCompanyStateRegistrationValue,
  parseHeadPositionInitialValue,
} from 'modules/client/common/helpers';
import { parseOrganizationalAndLegalFormValue } from 'modules/client/legal/helpers/getLegalClientInitialValue/parseOrganizationalAndLegalFormValue';

import { LegalClientLegalHeadFormType } from '../../forms/legalClientLegalHeadForm';

export const getLegalClientLegalHeadInitialValue = (
  client: LegalClientLegalHeadEntity,
  t: TFunc
): LegalClientLegalHeadFormType => ({
  reasonChange: { reason: '' },

  companyTaxResidences: client.taxResidences?.map((v) => ({
    country: v.country || null,
    taxNumber: v.taxId,
  })) || [{ country: null, taxNumber: '' }],

  companyRegistrationAddress: parseAddressValue(client.legalAddress),
  companyResidentialAddress: parseAddressValue(client.actualAddress),

  position: parseHeadPositionInitialValue(client, t),

  companyName: {
    fullName: client.fullName ?? '',
    shortName: client.shortName ?? '',
  },

  companyStateRegistration: parseCompanyStateRegistrationValue(
    client.stateRegistration
  ),

  activity: {
    id: client.id,
    createdAt: formatToDate(client.createdAt),
  },
  additionalDocumentsFiles: client.additionalInformationFiles,

  organizationalAndLegalForm: parseOrganizationalAndLegalFormValue(
    t,
    client.organizationalAndLegalForm
  ),
});
